import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { S3_URL } from "../services/Constants";
import { validateAndSanitizeUrl } from "../util/common";

const Configurations = () => {
  const [showSyphilisConfigurations, setShowSyphilisConfigurations] =
    useState(false);

  const showConfigurations = (option) => {
    option === "Syphilis"
      ? setShowSyphilisConfigurations(true)
      : setShowSyphilisConfigurations(false);
  };

  return (
    <>
      <Container fluid className="loincContainer">
        <Row style={{ marginLeft: "0px" }}>
          <Col xl={8}>
            <Row className="tableTitle generalFont">
              Disease Specific Configurations
            </Row>
            <Row className="tableSubtitle generalFont">
              View Diseasses that have configurations developed and execute
              business rules
            </Row>
          </Col>
        </Row>
        <Row style={{ marginLeft: "0px" }}>
          <Col xl={12} style={{ paddingLeft: "0px" }}>
            <div
              style={{
                background: "white",
                minHeight: "80px",
                display: "flex",
                alignItems: "center",
                maxWidth: "95%",
              }}
            >
              <Col sm={3} style={{ paddingLeft: "10px", paddingTop: "15px" }}>
                <Form.Group className="mb-3" controlId="form.condition">
                  <Form.Select
                    className="modalInput generalFont"
                    aria-label="Choose Item"
                    onChange={(e) => showConfigurations(e.target.value)}
                  >
                    <option value="">Choose Disease</option>
                    <option value="Syphilis">Syphilis</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </div>
          </Col>
        </Row>
        {showSyphilisConfigurations && (
          <>
            <Row style={{ marginLeft: "0px" }}>
              <Col xl={8}>
                <Row className="tableTitle generalFont">
                  Test Combinations Table
                </Row>
                <Row className="tableSubtitle generalFont">
                  Table used to determine if incoming Syphilis Test denotes
                  Active or Inactive Syphilis
                </Row>
              </Col>
            </Row>
            <Row
              style={{
                paddingLeft: "0px",
                maxWidth: "96%",
                paddingTop: "40px",
              }}
            >
              <img style={{width: '2500px'}} src={`${validateAndSanitizeUrl(S3_URL)}test-combination.png`} alt=""></img>
            </Row>
            <Row style={{ marginLeft: "0px" }}>
              <Col xl={8}>
                <Row className="tableTitle generalFont">Reactor Grid Table</Row>
                <Row className="tableSubtitle generalFont">
                  Table used to determine Case Creation for incoming Syphilis
                  Tests
                </Row>
              </Col>
            </Row>
            <Row
              style={{
                paddingLeft: "0px",
                maxWidth: "96%",
                paddingTop: "40px",
              }}
            >
              <img style={{width: '2500px'}} src={`${validateAndSanitizeUrl(S3_URL)}reactor-grid.png`} alt=""></img>
            </Row>
          </>
        )}
      </Container>
    </>
  );
};

export default Configurations;
